import React from 'react';
import { WARRANTY_YEARS } from '../../config/warranty';

// Four-icon value-strip below the product map: Australia-Wide Supply,
// Delivery Included, Built to Spec, 3 Year Warranty. Static copy.
// The Heroicons-style SVGs are inlined here — they're not shared
// elsewhere on the site.
export default function ValueStrip() {
  return (
    <section className="asg-value-strip">
      <div className="asg-value-strip-inner">
        <div className="asg-value-item">
          <svg className="asg-value-icon" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
            <path d="M8.25 18.75a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m3 0h6m-9 0H3.375a1.125 1.125 0 0 1-1.125-1.125V14.25m17.25 4.5a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m3 0H21a.75.75 0 0 0 .75-.75v-3.375M3.375 14.25h.008M21.75 12V9.75a3 3 0 0 0-3-3h-1.5L15 3H9L6.75 6.75h-1.5a3 3 0 0 0-3 3V12" />
          </svg>
          <div className="asg-value-text">Australia-Wide Supply</div>
          <div className="asg-value-sub">Pergolas shipped nationwide</div>
        </div>
        <div className="asg-value-item">
          <svg className="asg-value-icon" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
            <path d="M21 11.25v8.25a1.5 1.5 0 0 1-1.5 1.5H5.25a1.5 1.5 0 0 1-1.5-1.5v-8.25M12 4.875A2.625 2.625 0 1 0 9.375 7.5H12m0-2.625V7.5m0-2.625A2.625 2.625 0 1 1 14.625 7.5H12m0 0V21m-8.25-9.75h16.5" />
          </svg>
          <div className="asg-value-text">Free Delivery</div>
          <div className="asg-value-sub">To most of Melbourne</div>
        </div>
        <div className="asg-value-item">
          <svg className="asg-value-icon" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
            <path d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
          </svg>
          <div className="asg-value-text">Built to Spec</div>
          <div className="asg-value-sub">Australian-engineered, made to order</div>
        </div>
        <div className="asg-value-item">
          <svg className="asg-value-icon" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
            <path d="M9 12.75 11.25 15 15 9.75m-3-7.036A11.959 11.959 0 0 1 3.598 6 11.99 11.99 0 0 0 3 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285Z" />
          </svg>
          <div className="asg-value-text">{WARRANTY_YEARS} Year Warranty</div>
          <div className="asg-value-sub">From the date of delivery</div>
        </div>
      </div>
    </section>
  );
}
